import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { AppState } from '../../../../store/appSlice'
import { useAppSelector } from '../../../../store'
import api from '../../../../api'
import Responsive from '../../../../assets/config/Responsive'
import CarIcon from '../../../../assets/icons/JSX/CarIcon'
import CarSmallIcon from '../../../../assets/icons/JSX/CarSmallIcon'
import Colors from '../../../../assets/styles/Colors'
import Accordion from '../../../../components/Accordion'
import DownloadButton from '../../../../components/DownloadButton'
import Loader from '../../../../components/Loader'
import NotFound404 from '../../../../components/NotFound404'
import PaymentSchedule from '../../../../components/PaymentSchedule'
import { ScheduleType, currencySymbol, georgianFormatter } from '../../../../domain/types'
import { toast } from 'react-toastify'
import PendingPayments from '../../payment/PendingPayments'
import PayButton from '../../../../components/PayButton'
import TrashButton from '../../../../components/TrashButton'
import PendingPayModal from '../../../../components/modals/PendingPayModal'
import DeleteModal from '../../../../components/modals/DeleteModal'
import FailIcon from '../../../../assets/icons/JSX/FailIcon'
import Button from '../../../../components/v2/buttons/Button'
import axios from 'axios'
import { saveAs } from 'file-saver'

export default function InternationalTplPolicyDetail() {
  const { t } = useTranslation()
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { policyId: policyIdStr = '0' } = useParams()
  const policyIdToNumber = Number.parseInt(policyIdStr, 10)

  const [activeTab, setActiveTab] = React.useState('1')
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
  }

  const {
    data: policyDetailData,
    isFetching: isPolicyDetailLoading,
    refetch: policyDetailRefetch,
  } = api.useGetUserCurrentPoliciesQuery(policyIdToNumber)

  const policyDetail = policyDetailData as any

  console.log('detail: ', policyDetail)

  const orderId = policyDetail?.mainPolicy?.orderItems?.[0]?.orderId
  const { data: paymentScheduleData, isLoading: isPaymentScheduleDataLoading } = api.useGetTplPaymentScheduleQuery(
    {
      orderId,
    },
    {
      skip: orderId ? false : true,
    },
  )

  const { data: paymentTransactions, isLoading: isPaymentTransactionLoading } = api.useGetTplTransactionsQuery(
    {
      orderId,
    },
    {
      skip: orderId ? false : true,
    },
  )

  const { data: paymentMethods, isLoading: isPaymentMethodsLoading } = api.useGetTplPaymentMethodsQuery(undefined)

  // Calculate days difference
  const start = dayjs(policyDetail?.mainPolicy?.startDate)
  const end = dayjs(policyDetail?.mainPolicy?.endDate)
  const diffInDays = end.diff(start, 'day')

  // Helper function to calculate engine displacement
  const calculateEngineDisplacement = (digit: string) => {
    if (!digit || digit.length < 1) return

    if (/^\d+(\.\d+)?$/.test(digit) && digit.includes('.')) {
      return digit
    }

    const displacement = Number(digit) / 1000
    const roundedDisplacement = displacement.toFixed(1)
    return roundedDisplacement
  }

  const downloadPdf = (event: Event, url?: string) => {
    event?.stopPropagation()
    if (url) {
      const fileName = url?.split('frani.com/')?.[1] || 'file name not found'
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
        .then((response) => {
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
          saveAs(pdfBlob, fileName)
        })
        .catch((error) => {
          toast.error('ფაილის ჩამოტვირთვისას მოხდა შეცდომა:', error)
        })
    }
  }

  const _scheduleArray = () => {
    if (paymentScheduleData) {
      const formatedData: ScheduleType = {
        nextPaymentAmount: georgianFormatter.format(paymentScheduleData.nextPaymentAmount),
        totalPaymentAmount: georgianFormatter.format(paymentScheduleData.totalRemainedPaymentAmount),
        nextPaymentDate: paymentScheduleData.nextPaymentDate,
        currency: paymentScheduleData.currency,
        schedule: paymentScheduleData.payments?.map((item) => ({
          amount: georgianFormatter.format(item.amount),
          name: dayjs(item.detailJson?.paymentDate).format('MMM'),
          passed: item.status === 'paid' ? true : false,
          active:
            dayjs(paymentScheduleData?.nextPaymentDate).format('MMMM') ===
              dayjs(item.detailJson?.paymentDate).format('MMMM') && item.status !== 'paid'
              ? true
              : false,
        })),
      }
      return formatedData
    }
    return undefined
  }

  const paymentScheduleArray = _scheduleArray()

  const [openDialogModal, setOpenDialogModal] = React.useState<boolean>(false)
  const _onCloseDialogMOdal = () => {
    setOpenDialogModal(false)
  }

  const [deletePendingPolicy, { isLoading: isDeletePendingPolicyLoading }] = api.useDeleteUserPendingPolicyMutation()
  const deleteSelectedPendingPolicy = async () => {
    try {
      await deletePendingPolicy(policyIdToNumber).unwrap()
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (deleteSelectedPendingPolicy)')
      }
    }
    window.location.href = '/my-policies'
  }

  const [openDeleteModal, setOpenDeleteModal] = React.useState<boolean>(false)
  const _onCloseDeleteModal = () => {
    setOpenDeleteModal(false)
  }

  const [createOrder, { data: createPendingNewOrder, isLoading: isCreatePendingNewOrderLoading }] =
    api.useCreateUserPendingNewOrderMutation()

  const paySelectedPendingPolicies = async () => {
    try {
      const response = await createOrder({
        policyIds: [policyIdToNumber],
        targetType: policyDetail?.mainPolicy?.targetType,
      }).unwrap()
      if ('orderItems' in response) {
        setOpenDialogModal(true)
        policyDetailRefetch()
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (102)')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (110)')
      }
    }
  }

  const normalizeAmount = (value: unknown) => {
    if (value === null || value === undefined) return 0
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0
    }
    if (typeof value === 'string') {
      const numericValue = Number(value.replaceAll(',', ''))
      return Number.isFinite(numericValue) ? numericValue : 0
    }
    return 0
  }

  const companyName = createPendingNewOrder?.orderItems?.[0]?.company?.[lang]?.title
  const amount = normalizeAmount(
    createPendingNewOrder?.orderItems?.[0]?.totalPrice ?? createPendingNewOrder?.order?.totalPrice,
  )
  const insuranceType = createPendingNewOrder?.orderItems?.[0]?.category?.[lang]?.title
  const paymentScheduleTypeSlug = paymentMethods?.find(
    (x) => x.id === createPendingNewOrder?.orderItems?.[0]?.paymentScheduleTypeId,
  )?.slug
  const eachPrice = normalizeAmount(createPendingNewOrder?.orderItems?.[0]?.eachPrice)
  const monthlyPrice = normalizeAmount(createPendingNewOrder?.orderItems?.[0]?.monthlyPrice)
  const slug = createPendingNewOrder?.orderItems?.[0]?.slug
  const orderTotalPrice = normalizeAmount(
    createPendingNewOrder?.orderItems?.[0]?.totalPrice ?? createPendingNewOrder?.order?.totalPrice,
  )
  const currency = createPendingNewOrder?.orderItems?.[0]?.currency
  const orderSingleInfo = {
    companyName: companyName,
    amount: amount,
    insuranceType: insuranceType,
    paymentScheduleType: paymentScheduleTypeSlug,
    eachPrice: eachPrice,
    monthlyPrice: monthlyPrice,
    slug: slug,
    totalPrice: orderTotalPrice,
    currency: currency,
  }
  const orderModalInfo = [orderSingleInfo]

  const [openPendingPayments, setOpenPendingPayments] = React.useState<boolean>(false)

  const orderIdForOrderInfo = createPendingNewOrder?.order?.id
  const totalPrice = normalizeAmount(
    createPendingNewOrder?.order?.totalPrice ?? createPendingNewOrder?.orderItems?.[0]?.totalPrice,
  )
  const currentPaymentAmount = normalizeAmount(
    createPendingNewOrder?.order?.currentPaymentAmount ??
      createPendingNewOrder?.order?.totalPrice ??
      createPendingNewOrder?.orderItems?.[0]?.totalPrice,
  )
  const discountUsed = createPendingNewOrder?.order?.discounted
  const validPromoCode = createPendingNewOrder?.order?.validPromoCode

  const orderInfo = {
    orderId: orderIdForOrderInfo,
    totalPrice: totalPrice,
    category: ['tpl'],
    paymentScheduleType: paymentScheduleTypeSlug,
    currentPaymentAmount: currentPaymentAmount,
    discountUsed: discountUsed,
    validPromoCode: validPromoCode,
  }

  // Extract data from nested structure
  const policyOptions = policyDetail?.mainPolicy?.options || policyDetail?.mainPolicy?.policyOptions
  const carInformation = policyOptions?.carInformation
  const insurerInformation = policyOptions?.insurerInformation
  const individualInfo = insurerInformation?.individualPersonalInformation
  const legalEntityInfo = insurerInformation?.legalEntityPersonalInformation
  const carOwnerInfo = policyOptions?.carOwnerInformation?.individualPersonalInformation
  const carOwnerLegalEntityInfo = policyOptions?.carOwnerInformation?.legalEntityPersonalInformation
  const insurerContactInfo = insurerInformation?.contactInformation
  const carOwnerContactInfo = policyOptions?.carOwnerInformation?.contactInformation

  // Get names - check individual first, then legal entity representative
  const getInsurerFirstName = () => {
    if (lang === 'ge') {
      return (
        individualInfo?.firstNameGe ||
        legalEntityInfo?.representativeInformation?.firstNameGe ||
        legalEntityInfo?.representativeInformation?.firstNameEn ||
        individualInfo?.firstNameEn ||
        policyDetail?.mainPolicy?.translations?.[lang]?.firstName
      )
    }

    return (
      individualInfo?.firstNameEn ||
      legalEntityInfo?.representativeInformation?.firstNameEn ||
      individualInfo?.firstNameGe ||
      policyDetail?.mainPolicy?.translations?.[lang]?.firstName
    )
  }

  const getInsurerLastName = () => {
    if (lang === 'ge') {
      return (
        individualInfo?.lastNameGe ||
        legalEntityInfo?.representativeInformation?.lastNameGe ||
        legalEntityInfo?.representativeInformation?.lastNameEn ||
        individualInfo?.lastNameEn ||
        policyDetail?.mainPolicy?.translations?.[lang]?.lastName
      )
    }

    return (
      individualInfo?.lastNameEn ||
      legalEntityInfo?.representativeInformation?.lastNameEn ||
      individualInfo?.lastNameGe ||
      policyDetail?.mainPolicy?.translations?.[lang]?.lastName
    )
  }

  const getCarOwnerFirstName = () => {
    if (lang === 'ge') {
      return (
        carOwnerInfo?.firstNameGe ||
        carOwnerLegalEntityInfo?.representativeInformation?.firstNameGe ||
        carOwnerLegalEntityInfo?.representativeInformation?.firstNameEn ||
        carOwnerInfo?.firstNameEn
      )
    }

    return (
      carOwnerInfo?.firstNameEn ||
      carOwnerLegalEntityInfo?.representativeInformation?.firstNameEn ||
      carOwnerInfo?.firstNameGe
    )
  }

  const getCarOwnerLastName = () => {
    if (lang === 'ge') {
      return (
        carOwnerInfo?.lastNameGe ||
        carOwnerLegalEntityInfo?.representativeInformation?.lastNameGe ||
        carOwnerLegalEntityInfo?.representativeInformation?.lastNameEn ||
        carOwnerInfo?.lastNameEn
      )
    }

    return (
      carOwnerInfo?.lastNameEn ||
      carOwnerLegalEntityInfo?.representativeInformation?.lastNameEn ||
      carOwnerInfo?.lastNameGe
    )
  }

  // Get vehicle type, usage type, and other translated values from package target
  const packageTarget = policyDetail?.mainPolicy?.package?.target
  const vehicleType = packageTarget?.vehicleTypes?.find((vt: any) => vt.id === carInformation?.vehicleTypeId)
  const usageType = packageTarget?.usageTypes?.find((ut: any) => ut.id === carInformation?.usageTypeId)

  // Get discount info
  const discount = policyDetail?.mainPolicy?.orderItems?.[0]?.order?.discount
  const orderItem = policyDetail?.mainPolicy?.orderItems?.[0]

  // Get payment schedule type
  const paymentScheduleType = orderItem?.paymentScheduleType

  // Get category text
  const getCategoryText = () => {
    if (policyDetail?.mainPolicy?.targetType === 'InternationalTplPolicy') {
      return t('TPLinsurance') || 'International TPL Insurance'
    }
    return ''
  }

  // Get status text
  const getStatusText = () => {
    const status = policyDetail?.mainPolicy?.status?.toLowerCase()
    if (lang === 'ge') {
      if (status === 'active') return 'აქტიური'
      if (status === 'pending') return 'მომლოდინე'
    }
    return policyDetail?.mainPolicy?.status
  }

  // Get gender text
  const getGenderText = (gender: string | undefined) => {
    if (lang === 'ge') {
      if (gender === 'female') return 'ქალი'
      if (gender === 'male') return 'კაცი'
    }
    return gender
  }

  const isMainLoading =
    isPolicyDetailLoading ||
    isPaymentScheduleDataLoading ||
    isPaymentTransactionLoading ||
    isCreatePendingNewOrderLoading ||
    isDeletePendingPolicyLoading ||
    isPaymentMethodsLoading

  return isMainLoading ? (
    <Loader />
  ) : !policyDetail ? (
    <NotFound404 />
  ) : openPendingPayments ? (
    <PendingPayments orderInfo={orderInfo} />
  ) : (
    <Wrapper>
      <MuiBox>
        <TabContext value={activeTab}>
          <BoxStyle>
            <MuiTabList onChange={handleChange} aria-label="lab API tabs example">
              <MuiTab label={t('inDetails')} value="1"></MuiTab>
              <MuiTab label={t('transactions')} value="2" />
            </MuiTabList>
            {policyDetail?.mainPolicy?.status?.toLowerCase() === 'active' ||
            policyDetail?.mainPolicy?.status?.toLowerCase() === 'closed' ? (
              <>
                {activeTab === '1' ? (
                  <Div>
                    <DownloadButton
                      style={{ marginLeft: 'auto' }}
                      onClick={(event) => downloadPdf(event, policyDetail.mainPolicy.policyPdfUrl)}
                    />
                  </Div>
                ) : null}
              </>
            ) : (
              <>
                {activeTab === '1' ? (
                  <Btns>
                    <PayButton
                      text="Pay"
                      onClick={() => {
                        paySelectedPendingPolicies()
                      }}
                    />
                    <TrashButton onClick={() => setOpenDeleteModal(true)} />
                  </Btns>
                ) : null}
              </>
            )}
          </BoxStyle>

          <MuiTabPanel value="1">
            <AccordionWrapper>
              <Accordion title={t('policyInfo')} openAccordion={true}>
                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('insuranceCompany')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {policyDetail?.mainPolicy?.package?.product?.company?.translations?.[lang]?.title}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('category')}</OffetTextLeftSide>
                  <OffetTextRightSide>{getCategoryText()}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('policyNumber')}</OffetTextLeftSide>
                  <OffetTextRightSide>{policyDetail?.mainPolicy?.policyNumber}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('startDate')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {dayjs(policyDetail?.mainPolicy?.startDate).format('DD MMMM YYYY')}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('endDate')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {dayjs(policyDetail?.mainPolicy?.endDate).format('DD MMMM YYYY')}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {diffInDays} {t('day')}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('limit')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {policyDetail?.mainPolicy?.compensationLimit}{' '}
                    {currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('releaseDate')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {dayjs(policyDetail?.mainPolicy?.updatedAt).format('DD MMMM YYYY | HH:mm')}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('status')}</OffetTextLeftSide>
                  <OffetTextRightSide>{getStatusText()}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('policePrice')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {discount === null
                      ? `${georgianFormatter.format(Number(orderItem?.eachPrice || 0))} ${currencySymbol(
                          policyDetail?.mainPolicy?.compensationCurrency,
                        )}`
                      : `${georgianFormatter.format(
                          Number(discount?.promoCode?.applyingDiscount?.actualAmount || 0),
                        )}  ${currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}`}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                {discount !== null && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('promoCode')}</OffetTextLeftSide>
                    <OffetTextRightSide>{discount?.promoCode?.code}</OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {paymentScheduleType && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('paymentSchedule')}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {paymentScheduleType?.translations?.[lang]?.title || paymentScheduleType?.slug}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}
              </Accordion>

              <Accordion title={t('insuredPersonInfo')} openAccordion={false}>
                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('firstName')}</OffetTextLeftSide>
                  <OffetTextRightSide>{getInsurerFirstName()}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('lastName')}</OffetTextLeftSide>
                  <OffetTextRightSide>{getInsurerLastName()}</OffetTextRightSide>
                </CheckInfoTextBox>

                {individualInfo?.clientTypeId === 1 && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('birthDay')}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {dayjs(policyDetail?.mainPolicy?.birthday || individualInfo?.birthDate).format('DD MMMM YYYY')}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{legalEntityInfo ? t('companyID') : t('personalNumber')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {individualInfo?.personalNumber ?? legalEntityInfo.identificationNumber}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                {individualInfo?.clientTypeId === 1 && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('gender')}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {getGenderText(policyDetail?.gender || individualInfo?.gender)}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                <CheckInfoTextBox>
                  <OffetTextLeftSide>
                    {legalEntityInfo ? t('countryOfRegistration') : t('cityzenship')}
                  </OffetTextLeftSide>
                  <OffetTextRightSide>
                    {policyDetail?.insuredPersonInfo?.registrationCountry ||
                      policyDetail?.citizenship ||
                      individualInfo?.citizenshipCountryCode ||
                      legalEntityInfo?.registrationCountryCode}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                {individualInfo?.clientTypeId && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('clientType') || 'Client Type'}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {packageTarget?.clientTypes?.find((ct: any) => ct.id === individualInfo.clientTypeId)
                        ?.translations?.[lang]?.name ||
                        packageTarget?.clientTypes?.find((ct: any) => ct.id === individualInfo.clientTypeId)
                          ?.translations?.en?.name ||
                        ''}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {insurerContactInfo?.email && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('email')}</OffetTextLeftSide>
                    <OffetTextRightSide>{insurerContactInfo.email}</OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {insurerContactInfo?.phoneNumber && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('phone')}</OffetTextLeftSide>
                    <OffetTextRightSide>+{insurerContactInfo.phoneNumber}</OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {legalEntityInfo && (
                  <>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('companyName') || 'Company Name'}</OffetTextLeftSide>
                      <OffetTextRightSide>{legalEntityInfo.companyName}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    {legalEntityInfo.identificationNumber && (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('identificationNumber') || 'Identification Number'}</OffetTextLeftSide>
                        <OffetTextRightSide>{legalEntityInfo.identificationNumber}</OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}
                  </>
                )}
              </Accordion>

              <Accordion title={t('vehicleInformation')} openAccordion={false}>
                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('countryOfRegistration')}</OffetTextLeftSide>
                  <OffetTextRightSide>{policyDetail?.carInformation?.registrationCountry}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('registerNumber')}</OffetTextLeftSide>
                  <OffetTextRightSide>{carInformation?.registrationNumber}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('vinCode')}</OffetTextLeftSide>
                  <OffetTextRightSide>{carInformation?.vinCode}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('usageType')}</OffetTextLeftSide>
                  <OffetTextRightSide>{policyDetail?.carInformation?.usageType}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('carType')}</OffetTextLeftSide>
                  <OffetTextRightSide>{policyDetail?.carInformation?.vehicleType}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('manufactoreYear')}</OffetTextLeftSide>
                  <OffetTextRightSide>{carInformation?.manufactureYear}</OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('engineCapacity')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {carInformation?.engineCapacity
                      ? `${calculateEngineDisplacement(carInformation.engineCapacity)}L`
                      : ''}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                {carInformation?.color && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('color')}</OffetTextLeftSide>
                    <OffetTextRightSide>{carInformation.color}</OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {carInformation?.documentNumber && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('documentNumber')}</OffetTextLeftSide>
                    <OffetTextRightSide>{carInformation.documentNumber}</OffetTextRightSide>
                  </CheckInfoTextBox>
                )}
              </Accordion>

              <Accordion title={t('carOwnerInformation')} openAccordion={false}>
                {(carOwnerInfo || carOwnerLegalEntityInfo) && (
                  <>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('firstName')}</OffetTextLeftSide>
                      <OffetTextRightSide>{getCarOwnerFirstName()}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('lastName')}</OffetTextLeftSide>
                      <OffetTextRightSide>{getCarOwnerLastName()}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{legalEntityInfo ? t('companyID') : t('personalNumber')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {carOwnerInfo?.personalNumber ?? carOwnerLegalEntityInfo?.identificationNumber}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    {individualInfo?.clientTypeId === 1 && (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('birthDay')}</OffetTextLeftSide>
                        <OffetTextRightSide>{dayjs(carOwnerInfo?.birthDate).format('DD MMMM YYYY')}</OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>
                        {legalEntityInfo ? t('countryOfRegistration') : t('cityzenship')}
                      </OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.carOwnerInformation?.registrationCountry}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    {carOwnerInfo?.gender && (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('gender')}</OffetTextLeftSide>
                        <OffetTextRightSide>{getGenderText(carOwnerInfo.gender)}</OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}

                    {carOwnerContactInfo?.email && (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('email')}</OffetTextLeftSide>
                        <OffetTextRightSide>{carOwnerContactInfo.email}</OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}

                    {carOwnerContactInfo?.phoneNumber && (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('phone')}</OffetTextLeftSide>
                        <OffetTextRightSide>+{carOwnerContactInfo.phoneNumber}</OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}

                    {carOwnerLegalEntityInfo && (
                      <>
                        <CheckInfoTextBox>
                          <OffetTextLeftSide>{t('companyName') || 'Company Name'}</OffetTextLeftSide>
                          <OffetTextRightSide>{carOwnerLegalEntityInfo.companyName}</OffetTextRightSide>
                        </CheckInfoTextBox>

                        {carOwnerLegalEntityInfo.identificationNumber && (
                          <CheckInfoTextBox>
                            <OffetTextLeftSide>
                              {t('identificationNumber') || 'Identification Number'}
                            </OffetTextLeftSide>
                            <OffetTextRightSide>{carOwnerLegalEntityInfo.identificationNumber}</OffetTextRightSide>
                          </CheckInfoTextBox>
                        )}
                      </>
                    )}
                  </>
                )}
              </Accordion>

              <Accordion title={t('documents')} openAccordion={false}>
                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('insuranceContract')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {policyDetail?.mainPolicy?.productWordingUrl ? (
                      <CustomATag href={policyDetail?.mainPolicy?.productWordingUrl} target={'_blank'}>
                        {policyDetail?.mainPolicy?.productWordingUrl}
                      </CustomATag>
                    ) : (
                      '-'
                    )}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                <CheckInfoTextBox>
                  <OffetTextLeftSide>{t('policyContract')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {policyDetail?.mainPolicy?.policyPdfUrl ? (
                      <CustomATag href={policyDetail?.mainPolicy?.policyPdfUrl} target={'_blank'}>
                        {policyDetail?.mainPolicy?.policyPdfUrl}
                      </CustomATag>
                    ) : (
                      '-'
                    )}
                  </OffetTextRightSide>
                </CheckInfoTextBox>

                {insurerInformation?.documents && insurerInformation.documents.length > 0 && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('insuredPersonDocuments') || 'Insured Person Documents'}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {insurerInformation.documents.map((doc: any) => (
                        <div key={`insurer-doc-${doc.documentTypeId}`}>
                          {doc.uploadedPages?.map((page: any) => (
                            <CustomATag
                              key={`insurer-doc-${doc.documentTypeId}-page-${page.page}`}
                              href={page.address}
                              target={'_blank'}
                            >
                              {t('document')} {doc.documentTypeId} - {t('page')} {page.page}
                            </CustomATag>
                          ))}
                        </div>
                      ))}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {carInformation?.documents && carInformation.documents.length > 0 && (
                  <CheckInfoTextBox>
                    <OffetTextLeftSide>{t('vehicleDocuments') || 'Vehicle Documents'}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {carInformation.documents.map((doc: any) => (
                        <div key={`vehicle-doc-${doc.documentTypeId}`}>
                          {doc.uploadedPages?.map((page: any) => (
                            <CustomATag
                              key={`vehicle-doc-${doc.documentTypeId}-page-${page.page}`}
                              href={page.address}
                              target={'_blank'}
                            >
                              {t('document')} {doc.documentTypeId} - {t('page')} {page.page}
                            </CustomATag>
                          ))}
                        </div>
                      ))}
                    </OffetTextRightSide>
                  </CheckInfoTextBox>
                )}

                {policyOptions?.carOwnerInformation?.documents &&
                  policyOptions.carOwnerInformation.documents.length > 0 && (
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('carOwnerDocuments') || 'Car Owner Documents'}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyOptions.carOwnerInformation.documents.map((doc: any) => (
                          <div key={`carowner-doc-${doc.documentTypeId}`}>
                            {doc.uploadedPages?.map((page: any) => (
                              <CustomATag
                                key={`carowner-doc-${doc.documentTypeId}-page-${page.page}`}
                                href={page.address}
                                target={'_blank'}
                              >
                                {t('document')} {doc.documentTypeId} - {t('page')} {page.page}
                              </CustomATag>
                            ))}
                          </div>
                        ))}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  )}
              </Accordion>
            </AccordionWrapper>
            {
              <PendingPayModal
                onClick={() => setOpenPendingPayments(true)}
                onClose={_onCloseDialogMOdal}
                isOpen={openDialogModal}
                orderModalInfo={orderModalInfo}
                orderInfo={orderInfo}
              >
                {t('paymentDetails')}
              </PendingPayModal>
            }
            {
              <DeleteModal onClose={_onCloseDeleteModal} isOpen={openDeleteModal}>
                <ModalItems>
                  <FailIcon />
                  <ModalText>{t('areYouSureYouWantToDelete')}</ModalText>
                  <Button onClick={deleteSelectedPendingPolicy} text={t('yesDelete')} fullWidth />
                  <Button
                    onClick={_onCloseDeleteModal}
                    text={t('cancel')}
                    buttonType="transparent"
                    style={{ border: 'none', marginTop: '10px' }}
                    fullWidth
                  />
                </ModalItems>
              </DeleteModal>
            }
          </MuiTabPanel>
          <MuiTabPanel value="2">
            {policyDetail?.mainPolicy?.orderItems?.[0]?.paymentScheduleType?.slug?.toLowerCase() ===
            'one-time' ? null : (
              <>
                <PaymentSchedule scheduleData={paymentScheduleArray} />
                <br />
                <br />
              </>
            )}

            <TransactionTitle>{t('transactionHistory')}</TransactionTitle>
            <TransactionsStyle>
              <TitleSection>
                <Title></Title>
                <Title>{t('company')}</Title>
                <Title>{t('policy')}#</Title>
                <Title>{t('date')}</Title>
                <Title>{t('value')}</Title>
                <TitleHideInMobile>{t('status')}</TitleHideInMobile>
              </TitleSection>
              {paymentTransactions?.map((item, index) => (
                <ContentStyles key={index}>
                  <Title>
                    <CarIconStyle />
                  </Title>
                  <Title>{item?.companyTranslations[lang]?.title}</Title>
                  <Title>{item?.policyNumber}</Title>
                  <Title>{dayjs(item.transferDate).format('DD.MM.YYYY')}</Title>
                  <Title>{georgianFormatter.format(item.transferAmount as number)}</Title>
                  <TitleHideInMobile>
                    <StatusSpan>
                      {item.status}
                      {item.status && (
                        <StatusBall
                          style={{
                            backgroundColor:
                              item.status === 'paid'
                                ? Colors.java
                                : item.status === 'pending'
                                ? Colors.Primary
                                : Colors.primaryRed,
                          }}
                        />
                      )}
                    </StatusSpan>
                  </TitleHideInMobile>
                </ContentStyles>
              ))}
              <br />
              {paymentTransactions?.map((item, index) => (
                <ContentStylesMobile key={index}>
                  <div>
                    <Title>
                      <CarSmallIconStyle />
                      {item.carRegistrationNumber}
                    </Title>
                    <Title>
                      <StatusSpan>
                        {item.status && (
                          <StatusBall
                            style={{
                              backgroundColor:
                                item.status === 'paid'
                                  ? Colors.java
                                  : item.status === 'pending'
                                  ? Colors.Primary
                                  : Colors.primaryRed,
                            }}
                          />
                        )}
                      </StatusSpan>
                    </Title>
                  </div>
                  <div>
                    <Title>{t('policy')}#:</Title>
                    <Title>{item.policyNumber}</Title>
                  </div>
                  <div>
                    <Title>{t('date')}:</Title>
                    <Title>{dayjs(item.transferDate).format('DD.MM.YYYY')}</Title>
                  </div>
                  <div>
                    <Title>{t('value')}:</Title>
                    <Title>
                      {georgianFormatter.format(item.transferAmount as number) +
                        currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                    </Title>
                  </div>
                </ContentStylesMobile>
              ))}
            </TransactionsStyle>
          </MuiTabPanel>
        </TabContext>
      </MuiBox>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100%;
  .MuiButtonBase-root {
    font-family: inherit;
  }
`

const Btns = styled.div`
  display: flex;
  margin-left: auto;
  ${Responsive.mobile} {
    margin-block: 24px;
  }
`

const ModalItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 50px 30px;
  ${Responsive.mobile} {
    padding: 0px;
  }
`

const ModalText = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 18px;
  color: ${Colors.primaryBlack};
`

const AccordionWrapper = styled.div``

const CheckInfoTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0px;
  }
  ${Responsive.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`

const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
`

const TransactionTitle = styled.h3`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 35px;
`

const StatusBall = styled.span`
  height: 7px;
  width: 7px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  margin-left: 5px;
  margin-top: 7px;
  ${Responsive.mobile} {
    margin-top: 6px;
  }
  ${Responsive.mobile} {
    margin-top: 0px;
  }
`

const StatusSpan = styled.span`
  ${Responsive.mobile} {
    margin-left: -13px;
    position: relative;
  }
`

const CarSmallIconStyle = styled(CarSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`

const CarIconStyle = styled(CarIcon)`
  margin-top: -15px;
`

const ContentStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  padding-top: 40px;
  margin-top: 40px;
  box-shadow: 160px -2px 0px ${Colors.grey};
  :nth-child(1) {
    box-shadow: none;
  }
  &:nth-child(2) {
    padding-top: 20px;
    margin-top: 0px;
    border-top: 0px;
    box-shadow: none;
  }
  div {
    text-align: left;
    :first-child {
      text-align: center;
    }
    :nth-child(8) {
      text-align: center;
    }
  }
  ${Responsive.laptop} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
`

const TitleSection = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  margin-bottom: 40px;
  div {
    color: ${Colors.primaryGrey};
    text-align: left;
    :nth-child(8) {
      text-align: center;
    }
  }
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    margin-bottom: 10px;
  }
`

const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  user-select: none;
  ${Responsive.laptop} {
    font-size: 12px;
  }
  ${Responsive.tablet} {
    font-size: 12px;
    padding-left: 0px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`

const TitleHideInMobile = styled(Title)`
  ${Responsive.mobile} {
    display: none;
  }
`

const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`

const TransactionsStyle = styled.div`
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  &:first-child {
    margin-bottom: 55px;
  }
  ${Responsive.mobile} {
    padding-inline: 24px;
    &:first-child {
      margin-bottom: 26px;
    }
  }
`

const Div = styled.div`
  display: block;
  margin-left: auto;
  cursor: pointer;
  ${Responsive.mobile} {
    display: flex;
    margin-block: 24px;
  }
`

const CustomATag = styled.a`
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration-color: ${Colors.primaryRed};
  color: ${Colors.primaryBlack};
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`

const MuiTabList = styled(TabList)`
  button {
    padding: 0px;
    margin-right: 60px;
    font-size: 18px;
    text-transform: none;

    &:last-child {
      margin-right: 0px;
    }
  }

  .MuiTabs-indicator {
    background-color: ${Colors.primaryBlack} !important;
  }

  .MuiTouchRipple-root {
    display: none !important;
  }
  ${Responsive.mobile} {
    button {
      margin-right: auto;
      font-size: 13px;
    }
  }
`

const MuiTab = styled(Tab)`
  color: ${Colors.primaryBlack} !important;
`

const MuiTabPanel = styled(TabPanel)`
  padding: 0px !important;
  margin-top: 45px;
  ${Responsive.mobile} {
    margin-top: 20px;
  }
`

const MuiBox = styled(Box)``

const BoxStyle = styled(Box)`
  display: flex;
  ${Responsive.mobile} {
    display: block;
  }
`
